import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from "rxjs";
import { TranslateService } from '@ngx-translate/core';
import { WawiSettings } from "../Model/User/WawiSettings";
import { WawiIntegration } from "../Model/Catalog/WawiIntegration";
import { CustomWawiField } from "../Model/Catalog/CustomWawiField";


@Injectable()
export class WawiSettingsService {

    constructor(private http: HttpClient, public translate: TranslateService) {

    }

    getDefaultWawiIntegration(wawi: WawiIntegration, wawiSettings: WawiSettings): WawiIntegration {
        if (wawi == null) {
            wawi = new WawiIntegration();
            wawi.customFields = new Array<CustomWawiField>();
        }

        let result = new WawiIntegration(wawi.wawiId, wawi.line1, wawi.line2, wawi.line3, wawi.line4, wawi.customFields);

        wawiSettings.customFields.forEach((field) => {
            const found = result.customFields.find((x) => x.order === field.order);
            if (!found) {
                let customField = new CustomWawiField();
                customField.order = field.order;
                customField.listId = field.listId;
                result.customFields.push(customField);
            }
        });

        return result;
    }

    getWawiSettings(customerId: string): Observable<WawiSettings> {
        const options = {
            headers: new HttpHeaders().append("Content-Type", "application/json"),
            params: new HttpParams().append("customerId", customerId).append("isLive", "true")
        }
        return (this.http.get<WawiSettings>("api/WawiSettings/GetWawiSettings", options)) as any;
    }

    update(settings: WawiSettings): Observable<number> {
        return (this.http.post("api/WawiSettings/Update", settings)) as any;
    }
}
